import {
  isChakraTheme,
  requiredChakraThemeKeys
} from "./chunk-A6NK776R.mjs";
import {
  foundations
} from "./chunk-6S44RLTW.mjs";
import "./chunk-7OKLMD4V.mjs";
import "./chunk-DDAHWWWN.mjs";
import "./chunk-C7H5GWRZ.mjs";
import "./chunk-4REDROSM.mjs";
import "./chunk-DJNGX4VH.mjs";
import "./chunk-AU77DZXY.mjs";
import "./chunk-OLDNEXT6.mjs";
import "./chunk-ZV5E32CG.mjs";
import {
  components
} from "./chunk-SWVNKJWQ.mjs";
import "./chunk-KGFPXNP4.mjs";
import "./chunk-WHSEAAWU.mjs";
import "./chunk-RBQSCDLK.mjs";
import "./chunk-JWDMXB2N.mjs";
import "./chunk-OIGZPHLT.mjs";
import "./chunk-6Y3UQESG.mjs";
import "./chunk-VGCCECBM.mjs";
import "./chunk-JDPWIQ7H.mjs";
import "./chunk-V3RHVDKJ.mjs";
import "./chunk-YSULOCDF.mjs";
import "./chunk-RSEFU3LC.mjs";
import "./chunk-IBL46MNN.mjs";
import "./chunk-Y6RR3LE6.mjs";
import "./chunk-EY6ACYQS.mjs";
import "./chunk-VQ2DUS6J.mjs";
import "./chunk-2T5TO72C.mjs";
import "./chunk-AQJ6AIMN.mjs";
import "./chunk-FIWRYWVW.mjs";
import "./chunk-HCMWF4U4.mjs";
import "./chunk-XNRZTTJ2.mjs";
import "./chunk-HOOF7HHD.mjs";
import "./chunk-QW3Z4V42.mjs";
import "./chunk-YJYMWHG4.mjs";
import "./chunk-PQSF5PVS.mjs";
import "./chunk-YZVOF4MP.mjs";
import "./chunk-RUW3STUO.mjs";
import "./chunk-D55YRTLZ.mjs";
import "./chunk-OYCZTG3L.mjs";
import "./chunk-X4O3JXYB.mjs";
import "./chunk-WFLWAEKG.mjs";
import "./chunk-GLS227WS.mjs";
import "./chunk-AP3MTUHH.mjs";
import "./chunk-PZHBQTKY.mjs";
import "./chunk-3XG4KRSA.mjs";
import "./chunk-C4P5PUHY.mjs";
import "./chunk-LOVLFPS5.mjs";
import "./chunk-NDGGJV23.mjs";
import "./chunk-5Z4IVOU3.mjs";
import {
  semanticTokens
} from "./chunk-HZX2OI7F.mjs";
import {
  styles
} from "./chunk-I4WK6NDQ.mjs";
import "./chunk-RT7D5LFX.mjs";
import "./chunk-T276HDLM.mjs";
import "./chunk-YOXAUO7A.mjs";
import "./chunk-O7XTKHT6.mjs";
import "./chunk-X4JBRTE2.mjs";
import "./chunk-G3IFUAY5.mjs";
import "./chunk-EBS47JIL.mjs";
import "./chunk-UTUD2BXK.mjs";

// src/index.ts
var direction = "ltr";
var config = {
  useSystemColorMode: false,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
};
var theme = {
  semanticTokens,
  direction,
  ...foundations,
  components,
  styles,
  config
};
var src_default = theme;
var baseTheme = {
  semanticTokens,
  direction,
  components: {},
  ...foundations,
  styles,
  config
};
export {
  baseTheme,
  src_default as default,
  isChakraTheme,
  requiredChakraThemeKeys,
  theme
};
